export const csrfToken = () => ($('meta[name="csrf-token"]').prop('content'));
